import { permissionAreaKeyNameOf } from "../../../helpers/permission.helpers";
import { InventoryArea } from "../../../models/roles";
import { MenuMainNode } from "./nodes";
import { MenuCustomKeys } from '../menu-custom-keys';

export function entityKeyResolver<T extends InventoryArea>(name: Extract<keyof T, string>): string { return name; };

export const inventoryMenu: MenuMainNode = {
    icon: 'inventoryIconTemplate',
    title: 'Menu.Inventory.Name',
    rootPath: '/inventory',
    areaPermissionKey: permissionAreaKeyNameOf('inventory'),
    children: [
        {
            title: 'Menu.Inventory.SerializedItems.Name',
            abbreviation: 'Menu.Inventory.SerializedItems.Abbreviation',
            link: '/inventory/serialized-items',
            entityPermissionKey: entityKeyResolver('serializedItems')
        },
        {
            title: 'Menu.Inventory.NonSerializedItems.Name',
            abbreviation: 'Menu.Inventory.NonSerializedItems.Abbreviation',
            link: '/inventory/non-serialized-items',
            entityPermissionKey: entityKeyResolver('nonSerializedItems')
        },
        {
            customKey: MenuCustomKeys.inventoryOrdersKey,
            title: 'Menu.Inventory.CustomizedOrders.Name',
            abbreviation: 'Menu.Inventory.CustomizedOrders.Abbreviation',
            link: '/inventory/inventory-orders',
            entityPermissionKey: entityKeyResolver('customizedOrders')
        },
        {            
            title: 'Menu.Inventory.InventoryReceipts.Name',
            abbreviation: 'Menu.Inventory.InventoryReceipts.Abbreviation',
            link: '/inventory/inventory-receipts',
            entityPermissionKey: entityKeyResolver('inventoryReceipts')
        },
        {
            title: 'Menu.Inventory.RepairInShop.Name',
            abbreviation: 'Menu.Inventory.RepairInShop.Abbreviation',
            link: '/inventory/repair-in-shop-serialized-items',
            entityPermissionKey: entityKeyResolver('repairInShop')
        },
        {
            customKey: MenuCustomKeys.returnItemsKey,
            title: 'Menu.Inventory.ReturnItems.Name',
            abbreviation: 'Menu.Inventory.ReturnItems.Abbreviation',
            link: '/inventory/return-serialized-items',
            entityPermissionKey: entityKeyResolver('returnItems')
        },
        {
            title: 'Menu.Inventory.InventoryAudits.Name',
            abbreviation: 'Menu.Inventory.InventoryAudits.Abbreviation',
            link: '/inventory/inventory-audits',
            entityPermissionKey: entityKeyResolver('inventoryAudits')
        },
        {          
            title: 'Menu.Inventory.InventoryAdjustments.Name',
            abbreviation: 'Menu.Inventory.InventoryAdjustments.Abbreviation',
            link: '/inventory/inventory-adjustments',
            entityPermissionKey: entityKeyResolver('inventoryAdjustments')
        },
    ]
};


